import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const TokenTimer = () => {
  const token = useSelector((state) => state.token); // Get token from Redux store
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let intervalId;

    if (token) {
      // Initialize the timer
      const savedStartTime = localStorage.getItem('tokenStartTime');
      const startTime = savedStartTime ? parseInt(savedStartTime, 10) : Date.now();
      localStorage.setItem('tokenStartTime', startTime);

      intervalId = setInterval(() => {
        const currentTime = Date.now();
        setElapsedTime(currentTime - startTime);
      }, 1000);
    } else {
      // Clear timer and reset state on token removal
      clearInterval(intervalId);
      localStorage.removeItem('tokenStartTime');
      setElapsedTime(0);
    }

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [token]);

  // Format time as hh:mm:ss
  const formatTime = (timeInMs) => {
    const totalSeconds = Math.floor(timeInMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center justify-center ">
      <div className="bg-white rounded-lg shadow-md p-8 w-80 text-center">
        {token ? (
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Session Timer</h2>
            <p className="mt-4 text-4xl font-bold text-blue-500">{formatTime(elapsedTime)}</p>
            <p className="mt-2 text-sm text-gray-600">Your session is active</p>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">No Active Session</h2>
            <p className="mt-4 text-sm text-gray-600">Please log in to start tracking your session.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TokenTimer;
